import React from 'react';
import { Loader2 } from 'lucide-react';

interface LoaderOverlayProps {
  isLoading: boolean;
  loadingText?: string;
  children?: React.ReactNode;
}

const LoaderOverlay = ({
  isLoading,
  loadingText = 'Loading...',
  children,
}: LoaderOverlayProps) => {
  if (!isLoading) {
    return <>{children}</>;
  }

  return (
    <>
      {}
      <div className="fixed inset-0 bg-white/30 backdrop-blur-[2px] z-50 flex items-center justify-center">
        <div className="flex flex-col items-center gap-3">
          <Loader2 className="h-10 w-10 text-blue-600 animate-spin" />
          <span className="text-sm font-medium text-blue-600">
            {loadingText}
          </span>
        </div>
      </div>
      {}
      <div className="pointer-events-none opacity-50 select-none">
        {children}
      </div>
    </>
  );
};

export default LoaderOverlay;
